<template>
	<div  class="home">
		<div class="col-md-offset-1 col-md-4">
			<div class="panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					SIMPLE PRICING
				</div>

				<div v-if="1==2"
                     style="padding:5px; text-align:left;">
					When protecting your file there is a single one-off payment based on the size of the file.
                    <hr>
                    <span  style="font-size:18px;">
                        File Protection: <b>£1</b> per MB, plus £1.
                    </span>                        
                    <hr>

					<b>No subscriptions. No recurring fees.</b>
					<br>
					<br>
					Examples:
                    <ul>
					<li>2.5 Mb PDF file would cost £4.</li>
					<li>250 Kb JPG file would cost £2.</li>
					<li>8.8 Mb ZIP file would cost £10.</li>
                    </ul>
					<br>
					The type of file does not affect the price, it is determined by file size only.
					<br><br>
					Payments are via PayPal so local currency will apply at the current exchange rate.
					<br><br>
                    A fair-use policy applies - see <router-link to="/terms">Terms and Conditions</router-link> for details.
				</div>
				<div v-else
                     style="padding:5px; text-align:left;">
					TBC
				</div>
			</div>
		</div>

		<div class="col-md-6">
			<div class="panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					WHAT YOU GET
				</div>

				<div style="padding:5px; text-align:left;">
					Your file is uploaded to FiledSafely via email attachment or website upload.
					<br>&nbsp;
					<ul>
						<li>
							<u>Secure file storage</u><br>
							Your data is stored and secured by a number of means:<ol>
								<li>Protected server storage.</li>
								<li>Secure Cloud storage.</li>
								<li>Encrypted multiple offline backups.</li>
							</ol>
							&nbsp;
						</li>
						<li>
							<u>Unique file DDNA fingerprint calculated and permanently stored</u><br>
							The contents of your file are used to generate a unique code that applies to only your data.
							And only your data can produce this code. This code is then permantently stored in the blockchain and publically available.
							<br>&nbsp;<br>
						</li>
						<li>
							<u>E-mail protection</u><br>
							FiledSafely includes an email feature that can keep track of the emails you send: its contents and recipients. Each recipient is then emailed directly
							letting them know the data they received has been registered with FiledSafely. This acts as a deterent against mis-use of the data you send. For example, in the case of a
							contract or agreement, it lets the recipeint know the document has been securely stored and its contents can be easily verified.
						</li>
					</ul>					
				</div>
			</div>
		</div>
	</div>
</template>


<script>

export default {
	name: 'pricing',

	components: {
	},
	
	data() {
		return {
			env: process.env.VUE_APP_ENV,
		}
	},
	
	created() {
	},

	mounted() {
	},

	destroyed() {
	},

	methods: {
	},
}

</script>
